import { apiAction } from 'client/redux/apiHelpers';

export const instancePvtdReadMeta = (types, id) => {
  return apiAction({
    endpoint: `/api/instance/pvtd/${id}/meta`,
    method: 'GET',
    types: types.map(type => ({type, meta: {id}})),
  });
};
